/* RNR Media Group — lazy image load assistance
   Added 2026-07-29. Revised 2026-08-06 for performance.

   REMOVED and why:
   1. Soft page-leave transition — it called preventDefault() on every
      internal link then waited 260ms via setTimeout before setting
      location.href. Every navigation on the site was delayed a quarter
      second before the browser was even told where to go.
   2. Scroll reveals — added .rnr-reveal (opacity:0) to every below-the-fold
      .shopify-section and relied on IntersectionObserver to reveal it.
      IntersectionObserver is globally monkey-patched by rnr-stability.js,
      whose observe() silently returns on non-Element targets, so a missed
      section stayed invisible with no console error.

   KEPT: the lazysizes tuning and the in-viewport force-load, which address
   blank placeholders on slow first loads. body.page-ready is still set so
   any other rule or script depending on it keeps working. */
(function () {
  'use strict';

  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  /* Widen the preload window: the theme ships loadMode 1 (in-view only). */
  var lazyCfg = (window.lazySizesConfig = window.lazySizesConfig || {});
  lazyCfg.loadMode = 2;
  lazyCfg.expand = 700;

  function forceVisibleImages() {
    if (!window.lazySizes || !window.lazySizes.loader) return;
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var els = document.querySelectorAll('img.lazyload, [data-bgset].lazyload, [data-bg].lazyload');
    for (var i = 0; i < els.length; i++) {
      var r = els[i].getBoundingClientRect();
      if (r.bottom > -200 && r.top < vh + 200) {
        try { window.lazySizes.loader.unveil(els[i]); } catch (e) { /* noop */ }
      }
    }
  }

  onReady(function () {
    /* Retained for compatibility: other code and styles may key off this. */
    document.body.classList.add('page-ready');

    forceVisibleImages();
    setTimeout(forceVisibleImages, 800);
    setTimeout(forceVisibleImages, 2500);
  });
})();
